import { ReactComponent as BaseSVG } from '../assets/Elområden-Danmark.svg';
import { ReactComponent as DK1SVG } from '../assets/Elområden-DK1.svg';
import { ReactComponent as DK2SVG } from '../assets/Elområden-DK2.svg';

const DenmarkMap = ({ onRegionSelect, selectedRegion }) => {
    const handleClick = (region) => {
        if (onRegionSelect) {
            onRegionSelect(region);
        }
    };

    return (
        <div className="relative w-full max-w-[1000px] mx-auto h-[600px] hidden md:flex md:items-center md:justify-center">
            <BaseSVG className="absolute top-0 left-0 w-full h-full" preserveAspectRatio="xMidYMid meet" />
            <DK1SVG 
                className={`absolute top-0 left-0 w-full h-full region pointer-events-none ${selectedRegion === 'DK1' ? 'active-dk1' : ''}`}
                onClick={() => handleClick('DK1')} 
                preserveAspectRatio="xMidYMid meet" 
            />
            <DK2SVG 
                className={`absolute top-0 left-0 w-full h-full region pointer-events-none ${selectedRegion === 'DK2' ? 'active-dk2' : ''}`}
                onClick={() => handleClick('DK2')} 
                preserveAspectRatio="xMidYMid meet" 
            />
        </div>
    );
};

export default DenmarkMap;